export default __webpack_public_path__ + "static/media/all-plants-background.35b1e550.png";